import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SnackbarComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressBarModule, TranslateModule],
  exports: [SnackbarComponent]
})
export class SnackbarModule {}
